<template>

    <ScaleBox
            :width="1980"
            :height="1080"
    >
        <div class="monitor">
            <!-- 头部 -->
            <div class="r-top">
                <div class="r-icon">
                    <img
                            :src="lang === 'en' ? maxEnLogo : maxLogo"
                            key="max-logo"
                    />
                </div>

                <div class="r-top-text">
                    <template v-for="item in exhibition">
                        <span class="item">{{item}}</span>
                    </template>
                </div>

                <div class="r-top-time">{{time}}</div>
            </div>

            <!-- 机器人数据展示 -->
            <div class="r-show-data">
                <div class="left-monitoring">
                    <video
                            id="videoLeftElement"
                            ref="videoLeft"
                            autoplay
                            muted
                    >
                    </video>

                    <div class="edition">
                        <!-- 版本 -->
                        <div class="tm">
                            <div style="text-align: center;line-height: 0">
                                <div style="background-color: #000;width: 60%;height: 5px;margin:10px auto;border-radius: 10px;"></div>
                                <img
                                        :src="fg"
                                        width="100%"
                                        style="line-height:0"
                                />
                                <img
                                        :src="dd"
                                        style="line-height:0"
                                />
                            </div>

                            <div class="edition-classification">
                                <Row
                                        class="text-row"
                                        v-for="(item,key) in version"
                                        :key="key"
                                >
                                    <Col
                                            span="24"
                                            class="text-key"
                                    >{{item.name}}</Col>
                                    <Col
                                            span="24"
                                            class="text-value"
                                    >{{item.value}}
                                    </Col>
                                </Row>
                            </div>

                        </div>

                        <!-- 经纬度list -->
                        <div
                                class="tm"
                                style="height:auto;width:270px;z-index: 3;margin-top: 5%"
                        >
                            <div style="text-align: center;padding-top: 10px">
                                <img :src="dd" />
                            </div>
                            <div style="padding: 10px;color: #FFFFFF;font-size: 15px;text-align: center">
                                <span>{{movement.var1}} , {{movement.var2}}</span>
                            </div>
                            <div style="margin-bottom: 30px">
                                <img
                                        :src="fg"
                                        width="100%"
                                />
                            </div>
                        </div>

                    </div>

                </div>
                <div class="right-monitoring">
                    <video
                            id="videoRightElement"
                            ref="videoRight"
                            autoplay
                            muted
                    >
                    </video>

                    <!--数据明细 -->
                    <div class="data-details">
                        <div class="tm">
                            <div style="text-align: center;line-height: 0">
                                <div style="background-color: #000;width: 60%;height: 5px;margin:10px auto;border-radius: 10px;"></div>
                                <img
                                        :src="fg"
                                        width="100%"
                                        style="line-height:0"
                                />
                                <img
                                        :src="dd"
                                        style="line-height:0"
                                />
                            </div>
                            <div class="detailed">
                                <Row
                                        class="text-row"
                                        v-for="(item,key) in status"
                                        :key="key"
                                >
                                    <Col
                                            span="24"
                                            class="text-key"
                                    >{{item.name}}</Col>
                                    <Col
                                            span="24"
                                            class="text-value"
                                    >{{item.value}}
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <div style="position:absolute;top: 100px;left: 20px;z-index: 3;">
                        </div>

                    </div>

                </div>
            </div>

            <!-- 底部 -->
            <div class="r-bottom">
                <h1
                        class="warning"
                        v-show="isShow2"
                >
                    <img
                            class="img"
                            v-if="warn.msg"
                            :src="warningImg"
                    >
                    <span>{{warn.msg}}</span>
                </h1>

                <!--罗盘-->
                <div class="sindagis-map-compass">
          <span
                  class="center"
                  :style="{transform: `rotate(${movement.direction}deg)`}"
          >
          </span>
                </div>

                <!--速度加速度-->
                <div class="speed">
                    <p style="color: red;line-height: 100px">
                        <strong style="font-size: 18px;color: #ffffff">
                            {{movement.speed}}
                        </strong>
                        <span style="font-size: 10px;color: red">m/s</span>
                        &nbsp;&nbsp;&nbsp;
                        <strong style="font-size: 18px;color: #ffffff">
                            {{movement.acceleration}}
                        </strong>
                        <span style="font-size: 10px;color: red">m/s2</span>
                    </p>
                </div>

                <!--控制区域-->
                <div class="data-details">
                    <div
                            class="tm"
                            style="padding-top: 13px;"
                    >
                        <!-- 网枪控制区域 -->
                        <Row class="kz">
                            <Col span="12">
                                <h2>{{langMap.fireNetGun[lang]}}<i
                                        v-if="gunData != null"
                                        style="font-size: 13px"
                                >({{formatTime(gunData.timestamp)}})</i></h2>
                            </Col>
                            <!-- 原有警情处理区域 -->
                            <Col span="12">
                                <h2>{{langMap.alarmDisposal[lang]}}<i
                                        v-if="sentimentData != null "
                                        style="font-size: 13px"
                                >({{formatTime(sentimentData.timestamp)}})</i></h2>
                            </Col>
                        </Row>
                        <div style="text-align: center;line-height: 0">
                            <img
                                    class="img"
                                    :src="fg"
                                    width="100%"
                                    style="line-height:0"
                            />
                        </div>
                        <Row class="kz">
                            <Col span="12">
                                <Button
                                        style="margin:5px;"
                                        class="sci-fi-btn netgun-btn"
                                        size="small"
                                        @click="fireNetGun('left')"
                                >{{langMap.left[lang]}}</Button>
                                <Button
                                        style="margin:5px;"
                                        class="sci-fi-btn netgun-btn"
                                        size="small"
                                        @click="fireNetGun('right')"
                                >{{langMap.right[lang]}}</Button>
                            </Col>
                            <Col span="12" class="operate">
                                <!-- 语音喊话按钮 -->
                                <Button
                                        style="margin:5px;"
                                        class="sci-fi-btn intercom-btn"
                                         type="primary"
                                        :disabled="sentimentData == null"
                                        @click="openIntercomModal"
                                >
                                    <Icon type="md-microphone" />
                                    {{langMap.voiceIntercomTitle[lang]}}
                                </Button>
                                
                                <!-- 音频播放按钮 -->
                                <Button
                                        style="margin:5px;"
                                        class="sci-fi-btn audio-play-btn"
                                        type="success"
                                        :disabled="sentimentData == null"
                                        @click="openAudioPlayerModal"
                                >
                                    <Icon type="md-musical-notes" />
                                    {{langMap.audioPlaybackTitle[lang]}}
                                </Button>
                                
                                <!-- 行为拒止功能 -->
                                <Button
                                        style="margin:5px;"
                                        class="sci-fi-btn behavior-prohibition-btn"
                                        type="warning"
                                        :disabled="sentimentData == null"
                                        @click="openBehaviorProhibitionModal"
                                >
                                    <Icon type="md-locate" />
                                    {{langMap.trackAttack[lang]}}
                                </Button>
                                
                                <!-- 停止行为拒止功能 -->
                                <Button
                                        style="margin:5px;"
                                        class="sci-fi-btn stop-behavior-btn"
                                        type="info"
                                        :disabled="sentimentData == null"
                                        @click="sentimentOperate(8, '')"
                                >
                                    <Icon type="md-hand" />
                                    {{langMap.stopBehaviorProhibition[lang]}}
                                </Button>
                                
                                <Button
                                        class="handle"
                                        style="margin:5px;"
                                        type="error"
                                        :disabled="sentimentData == null"
                                        @click="sentimentOperate(4, '')"
                                >
                                    <Icon type="md-checkmark" />
                                    {{langMap.noDisposal[lang]}}
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </div>

            </div>

            <!-- 不在线提示 -->
            <div
                    class="state"
                    v-if="offline"
            >
                <div style="margin:20% auto;width: 80%;text-align: center">
                    <p style="font-size: 30px;color: #FFFFFF">{{langMap.robotNotOnline[lang]}}</p>
                </div>
            </div>

            <h1
                    class="special"
                    v-show="isShow1"
            >
                <img
                        v-if="special.msg"
                        class="img"
                        :src="warningImg"
                >
                <span>{{special.msg}}</span>
            </h1>

        </div>
        
        <!-- 行为拒止弹窗组件 -->
        <BehaviorProhibitionModal
            :visible.sync="behaviorProhibitionModalVisible"
            :data="behaviorProhibitionData"
            :robot-code="currentBehaviorProhibitionData ? currentBehaviorProhibitionData.code : id"
            :timestamp="currentBehaviorProhibitionData ? currentBehaviorProhibitionData.timestamp : sentimentData?.timestamp"
            @success="onBehaviorProhibitionSuccess"
            @error="onBehaviorProhibitionError"
            @cancel="onBehaviorProhibitionCancel"
        />
        
        <!-- 音频播放弹窗组件 -->
        <AudioPlayerModal
            :visible="audioPlayerModalVisible"
            :robotInfo="audioPlayerRobotInfo"
            @close="closeAudioPlayerModal"
        />
        
        <!-- 语音对讲弹窗组件 -->
        <IntercomModal
            :visible="intercomModalVisible"
            :robotInfo="intercomRobotInfo"
            @close="closeIntercomModal"
        />
    </ScaleBox>

</template>

<script>
    import flvjs from "flv.js";
    import maxLogo from "@/assets/images/logo.png";
    import maxEnLogo from "@/assets/images/logo-en.png";
    import fg from "@/assets/images/lol/fg.png";
    import dd from "@/assets/images/lol/dd.png";
    import warning from "../../../assets/images/lol/Warning.png";
    import countTo from "vue-count-to";
    import * as timeUtil from "@/utils/dateTimeUtil.js";
    import api from "../../../api";
    import { sendMsg, buildWebSocketUrl, connectWithUrl } from "@/utils/websocket.js";
    import ScaleBox from "../../../components/scale-box/ScaleBox.vue";
    import langMap from '@/utils/language';
    import { mapState } from 'vuex';
import BehaviorProhibitionModal from '@/components/BehaviorProhibitionModal';
import AudioPlayerModal from '@/components/AudioPlayerModal';
import IntercomModal from '@/components/IntercomModal';
import { getSocketUrl } from '@/utils/websocket'

    export default {
        name: "hide",
        components: {
            countTo,
            ScaleBox,
            BehaviorProhibitionModal,
            AudioPlayerModal,
            IntercomModal
        },

        data() {
            return {
                langMap:langMap,
                id: "",
                timestamp: "",
                warningImg: warning,
                offline: false,
                fg,
                dd,
                time: "",
                maxLogo,
                maxEnLogo,
                rotate: 0,
                version: {},
                status: {},
                movement: {},
                notice: {},
                height: document.documentElement.clientHeight,
                videoPlayUrlPrefix: getSocketUrl()+'/video/',
                currentRobot: {},
                exhibition: ["R", "O", "T", "U", "N", "B", "O", "T"],
                notice: {},
                isShow1: false,
                isShow2: false,
                warn: {}, // 二级
                special: {}, // 一级
                specialNum: 0,
                warnNum: 0,
                sentimentData: null,
                gunData: null,
              leftFlvPlayer:null,
              rightFlvPlayer:null,
              
              // 行为拒止相关
              behaviorProhibitionModalVisible: false,
              behaviorProhibitionData: {},
              currentBehaviorProhibitionData: null,
              
              // 音频播放弹窗相关
              audioPlayerModalVisible: false,
              audioPlayerRobotInfo: {},
              
              // 语音对讲弹窗相关
              intercomModalVisible: false,
              intercomRobotInfo: {},
            };
        },
        computed: {
            ...mapState({
                lang: state => state.app.language,
            }),
        },
        methods: {
            formatTime(t) {
                if (!t) {
                    return "";
                }
                return timeUtil.formatTime(t);
            },
            sentimentOperate(type, item) {
                let msg = "";
                switch (type) {
                    case 1:
                        msg = langMap.confirmPlayWarning[this.lang];
                        break;
                    case 2:
                        msg = langMap.confirmTalkInspection[this.lang];
                        break;
                    case 3:
                        msg = langMap.confirmTrackTarget[this.lang];
                        break;
                    case 4:
                        msg = langMap.confirmIgnoreAlarm[this.lang];
                        break;
                    case 8:
                        msg = langMap.confirmStopBehaviorProhibition[this.lang];
                        break;
                }
                // let data = this.sentimentData;
                let _that = this;
                this.$Modal.confirm({
                    title: langMap.systemTip[this.lang],
                    content: msg,
                    onOk: () => {
                        this.$Spin.show();
                        let d = {
                            timestamp: _that.sentimentData.timestamp,
                            ret: type,
                            item: item
                        };
                        api
                            .postData(
                                "notice-server/cmd/sentiment",
                                { robotId: _that.id, data: d },
                                this
                            )
                            .then(res => {
                                if (res.state == 0) {
                                    this.$Notice.error({
                                        title: langMap.tip[this.lang],
                                        desc: res.msg
                                    });
                                } else {
                                    this.$Notice.success({
                                        title: langMap.success[this.lang],
                                        desc: res.message
                                    });
                                    _that.sentimentData = null;
                                }
                                this.$Spin.hide();
                            });
                    }
                });
            },
            // 网枪控制方法
            fireNetGun(direction) {
                let confirmContent = direction === 'left' ? 
                    langMap.confirmFireLeftNetGun[this.lang] : 
                    langMap.confirmFireRightNetGun[this.lang];
                
                this.$Modal.confirm({
                    title: langMap.systemTip[this.lang],
                    content: confirmContent,
                    okText: langMap.confirm[this.lang],
                    cancelText: langMap.cancel[this.lang],
                    onOk: () => {
                        this.$Spin.show();
                        const devicePosition = direction === 'left' ? 0 : 1; // 0-左, 1-右
                        this.sendBatchCommand(this.currentRobot.code, [
                            {
                                "deviceType": 1, // 1-网枪
                                "devicePosition": devicePosition,
                                "operate": 2, // 2-激发
                                "duration": 0 // 0-默认即可
                            }
                        ]);
                    }
                });
            },
            // 批量命令发送方法
            sendBatchCommand(code, switchDeviceList) {
                const params = {
                    code,
                    data: {
                        switchDeviceList
                    }
                };
                api
                    .postData("notice-server/cmd/switch/device", params, this)
                    .then(res => {
                        if (res.state == 0) {
                            this.$Notice.error({
                                title: langMap.tip[this.lang],
                                desc: res.msg
                            });
                        } else {
                            this.$Notice.success({
                                title: langMap.success[this.lang],
                                desc: res.message
                            });
                        }
                        this.$Spin.hide();
                    });
            },

            // 保留原有的gunOperate方法作为备用
            gunOperate(flag) {
                let _that = this;
                this.$Modal.confirm({
                    title: langMap.systemTip[this.lang],
                    content: flag ? langMap.confirmOpenNetGun[this.lang] : langMap.confirmRejectOperation[this.lang],
                    onOk: () => {
                        this.$Spin.show();
                        let d = {
                            timestamp: _that.timestamp,
                            flag: flag
                        };
                        api
                            .postData(
                                "notice-server/cmd/gun",
                                { robotId: _that.id, data: d },
                                this
                            )
                            .then(res => {
                                if (res.state == 0) {
                                    this.$Notice.error({
                                        title: langMap.tip[this.lang],
                                        desc: res.msg
                                    });
                                } else {
                                    this.$Notice.success({
                                        title: langMap.success[this.lang],
                                        desc: res.message
                                    });
                                    _that.gunData = null;
                                }
                                this.$Spin.hide();
                            });
                    }
                });
            },
            
            // 行为拒止相关方法
            openBehaviorProhibitionModal() {
                this.behaviorProhibitionData = {
                    msg: this.sentimentData.msg || '',
                    img: this.sentimentData.img || '',
                    x:data.x,
                    y:data.y,
                    z:data.z,
                    targetList: this.sentimentData.targetList
                };
                    
                this.currentBehaviorProhibitionData = {
                    code: this.sentimentData.code,
                    timestamp: this.sentimentData.timestamp
                };
                    
                this.behaviorProhibitionModalVisible = true;
            },
            
            // 行为拒止成功回调
            onBehaviorProhibitionSuccess(res) {
                console.log('行为拒止成功:', res);
                // 清除当前的情感数据
                this.sentimentData = null;
            },
            
            // 行为拒止错误回调
            onBehaviorProhibitionError(error) {
                console.error('行为拒止错误:', error);
            },
            
            // 行为拒止取消回调
            onBehaviorProhibitionCancel() {
                this.currentBehaviorProhibitionData = null;
                this.behaviorProhibitionData = {};
            },
            
            // 打开音频播放弹窗
            openAudioPlayerModal() {
                if (!this.currentRobot || !this.currentRobot.id) {
                    this.$Notice.error({
                        title: langMap.tip[this.lang],
                        desc: langMap.robotRequired[this.lang]
                    });
                    return;
                }
                
                // 设置机器人信息
                this.audioPlayerRobotInfo = {
                    id: this.currentRobot.id,
                    name: this.currentRobot.name,
                    serialNumber: this.currentRobot.code,
                    avatar: this.currentRobot.avatar || require('@/assets/images/voice/Robot-icon.png')
                };
                this.audioPlayerModalVisible = true;
            },
            
            // 关闭音频播放弹窗
            closeAudioPlayerModal() {
                this.audioPlayerModalVisible = false;
                this.audioPlayerRobotInfo = {};
            },
            
            // 打开语音对讲弹窗
            openIntercomModal() {
                if (!this.currentRobot || !this.currentRobot.id) {
                    this.$Notice.error({
                        title: langMap.tip[this.lang],
                        desc: langMap.robotRequired[this.lang]
                    });
                    return;
                }
                
                // 设置机器人信息
                this.intercomRobotInfo = {
                    id: this.currentRobot.id,
                    name: this.currentRobot.name,
                    serialNumber: this.currentRobot.code,
                    avatar: this.currentRobot.avatar || require('@/assets/images/voice/Robot-icon.png')
                };
                this.intercomModalVisible = true;
            },
            
            // 关闭语音对讲弹窗
            closeIntercomModal() {
                this.intercomModalVisible = false;
                this.intercomRobotInfo = {};
            },
            
            start() {
                // 将定时器名字赋值到变量中
                this.timer = setInterval(() => {
                    this.time = timeUtil.formatTime(new Date().getTime());
                }, 1000);
            },
            //新建flv实例
            // flvjs  视频播放器
            createFlvPlayer() {
                if (flvjs.isSupported()) {
                    // console.log(this.videoPlayUrlPrefix);
                    // console.log(this.currentRobot.code);
                    var leftVideoElement = this.$refs.videoLeft;
                     this.leftFlvPlayer = flvjs.createPlayer({
                        type: "flv",
                        url: this.videoPlayUrlPrefix + "_left_" + this.currentRobot.code,
                        isLive: true,
                        cors: true,  // 开启跨域访问
                        duration:0,
                        currentTime:0,
                    },{
                      autoCleanupSourceBuffer:true, //对SourceBuffer进行自动清理
                      autoCleanupMaxBackwardDuration:12,//    当向后缓冲区持续时间超过此值（以秒为单位）时，请对SourceBuffer进行自动清理
                      autoCleanupMinBackwardDuration:8,//指示进行自动清除时为反向缓冲区保留的持续时间（以秒为单位）。
                      enableStashBuffer: false, //关闭IO隐藏缓冲区
                      isLive: true,
                      lazyLoad: false,
                    });
                  this.leftFlvPlayer.attachMediaElement(leftVideoElement);
                  this.leftFlvPlayer.load();
                  this.leftFlvPlayer.play();

                    var rightVideoElement = this.$refs.videoRight;
                    this.rightFlvPlayer = flvjs.createPlayer({
                        type: "flv",
                        url: this.videoPlayUrlPrefix + "_right_" + this.currentRobot.code,
                        isLive: true,
                        cors: true,  // 开启跨域访问
                        duration:0,
                        currentTime:0,
                    },{
                      autoCleanupSourceBuffer:true, //对SourceBuffer进行自动清理
                      autoCleanupMaxBackwardDuration:12,//    当向后缓冲区持续时间超过此值（以秒为单位）时，请对SourceBuffer进行自动清理
                      autoCleanupMinBackwardDuration:8,//指示进行自动清除时为反向缓冲区保留的持续时间（以秒为单位）。
                      enableStashBuffer: false, //关闭IO隐藏缓冲区
                      isLive: true,
                      lazyLoad: false,
                    });
                  this.rightFlvPlayer.attachMediaElement(rightVideoElement);
                  this.rightFlvPlayer.load();
                  this.rightFlvPlayer.play();


                  let _that = this;
                  let flag = false;
                  //用于视频延时，超过1分钟，就关闭当前流且重新拉流； 每2s循环监听一次
                  let timer =setInterval(() => { // ->注意：这里的定时器，在中断视频时，要清理哦
                    if(_that.rightFlvPlayer){
                      if (_that.rightFlvPlayer.buffered && _that.rightFlvPlayer.buffered.length) {
                        let end = _that.rightFlvPlayer.buffered.end(0);//获取当前buffered值
                        let diff = end - _that.rightFlvPlayer.currentTime;//获取buffered与currentTime的差值
                        if (diff >= 5) {//如果差值大于等于60s 手动跳帧 这里可根据自身需求来定
                          //单个视频用
                          // flvPlayer.currentTime = end;//手动跳帧
                          // flvPlayer.currentTime = flvPlayer.buffered.end(0);//手动跳帧
                          flag = true;
                        }
                      }
                    }
                    if(_that.leftFlvPlayer){
                      if (_that.leftFlvPlayer.buffered && _that.leftFlvPlayer.buffered.length) {
                        let end = _that.leftFlvPlayer.buffered.end(0);//获取当前buffered值
                        let diff = end - _that.leftFlvPlayer.currentTime;//获取buffered与currentTime的差值
                        if (diff >= 5) {//如果差值大于等于60s 手动跳帧 这里可根据自身需求来定
                          //单个视频用
                          // flvPlayer.currentTime = end;//手动跳帧
                          // flvPlayer.currentTime = flvPlayer.buffered.end(0);//手动跳帧
                          flag = true;
                        }
                      }
                    }
                    if(flag){
                      //多个视频用
                      _that.refPlay(timer, _that);
                    }
                  }, 2000); //2000毫秒执行一次

                  _that.leftFlvPlayer.on(flvjs.Events.ERROR, (errorType, errorDetail, errorInfo) => {
                    //视频出错后销毁重新创建
                    if (_that.leftFlvPlayer) {
                      _that.refPlay(timer, _that);
                    }
                  });
                  _that.rightFlvPlayer.on(flvjs.Events.ERROR, (errorType, errorDetail, errorInfo) => {
                    //视频出错后销毁重新创建
                    if (_that.rightFlvPlayer) {
                      _that.refPlay(timer, _that);
                    }
                  });
                }
            },

            refPlay(timer, _that){
              //多个视频用
              clearInterval(timer)
              _that.leftFlvPlayer.pause();
              _that.leftFlvPlayer.unload();
              _that.leftFlvPlayer.detachMediaElement();
              _that.leftFlvPlayer.destroy();
              _that.leftFlvPlayer= null;

              _that.rightFlvPlayer.pause();
              _that.rightFlvPlayer.unload();
              _that.rightFlvPlayer.detachMediaElement();
              _that.rightFlvPlayer.destroy();
              _that.rightFlvPlayer= null;
              //重新加载当前停止的视频流，根据个人的方法来配置
              this.createFlvPlayer();
            },

            //
            initSocket() {
                connectWithUrl('/ssdd', "dataSocketUrl", this.id, this.dataCallback);
            },
            dataCallback(data) {
                this.offline = false;
                //console.log(data);
                let ret = JSON.parse(data);
                switch (ret.type) {
                    case "fail":
                        this.$Notice.error({
                            title: langMap.tip[this.lang],
                            desc: ret.data
                        });
                        this.offline = true;
                        break;
                    case "online:":
                        this.offline = false;
                        this.createFlvPlayer();
                        break;
                    case "offline:":
                        this.offline = true;
                        break;
                    case "status:":
                        this.status = ret.data;
                        break;
                    case "movement:":
                        this.movement = ret.data;
                        break;
                    case "version:":
                        this.version = ret.data;
                        break;
                    case "notice:":
                        this.notice = ret.data;
                        if (ret.data.type === 1) {
                            this.specialNum = 11;
                            if (!this.isShow1) {
                                this.showSpecial(ret.data);
                            }
                        } else if (ret.data.type === 0) {
                            this.warnNum = 11;
                            if (!this.isShow2) {
                                this.showWarn(ret.data);
                            }
                        }
                        break;
                    case "gun:":
                        this.gunData = ret.data;
                        break;
                    case "sentiment:":
                        this.sentimentData = ret.data;
                        break;
                }
            },

            // 倒数10秒
            async showSpecial(data) {
                this.special = data;
                while (this.specialNum >= 0) {
                    this.isShow1 = true;
                    const logStr = await this.sleepFun(this.specialNum);
                    // console.log("special---" + logStr);
                    this.specialNum = this.specialNum - 1;
                }
                this.isShow1 = false;
            },
            async showWarn(data) {
                this.warn = data;
                while (this.warnNum >= 0) {
                    this.isShow2 = true;
                    const logStr = await this.sleepFun(this.warnNum);
                    // console.log("warn---" + logStr);
                    this.warnNum = this.warnNum - 1;
                }
                this.isShow2 = false;
            },
            sleepFun(logStr) {
                return new Promise(res => {
                    return setTimeout(() => {
                        res(logStr);
                    }, 1000);
                });
            },
            getInfo(id) {
                api.getData("robot-server/robot/get/" + id, this).then(res => {
                    if (res.state == 0) {
                        this.$Notice.error({
                            title: langMap.tip[this.lang],
                            desc: res.msg
                        });
                    } else {
                        this.currentRobot = res.data;
                        if (!this.offline) {
                            this.createFlvPlayer();
                        }
                    }
                });
            },
            getHandle() {
                if (this.id && this.timestamp) {
                    api
                        .getData(
                            "notice-server/data/get/handle?robotId=" +
                            this.id +
                            "&timestamp=" +
                            this.timestamp,
                            this
                        )
                        .then(res => {
                            if (res.state == 0) {
                                this.$Notice.error({
                                    title: langMap.tip[this.lang],
                                    desc: res.msg
                                });
                            } else {
                                this.gunData = res.data.gunData;
                                this.sentimentData = res.data.sentimentData;
                            }
                        });
                }
            }
        },

        watch: {
            // notice() {
            //   if (this.notice.type === 1 && this.notice) {
            //     console.log("一级预警");
            //     this.alarmDisplay();
            //   } else {
            //     console.log("二级预警");
            //     this.alarmDisplay();
            //   }
            // }
        },
        mounted() {
            //this.createFlvPlayer();
            this.start();
            this.initSocket();
            this.getHandle();
        },
        created() {
            this.id = this.$route.query.id;
            this.timestamp = this.$route.query.timestamp;
            //this.initSocket();
        }
    };
</script>


<style scoped  lang="less">
    .kz {
        text-align: center;
        padding: 5px 20px 5px 20px;
        font-size: 15px;
        color: red;
    }
    .monitor {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;

        .special {
            position: absolute;
            top: 25%;
            left: 44%;
            color: red;
            font-size: 45px;
            text-align: center;
            line-height: 100px;
            font-weight: bold;
            animation: blink 1s linear infinite;
            -webkit-animation: blink 1s linear infinite;
            -moz-animation: blink 1s linear infinite;
            -ms-animation: blink 1s linear infinite;
            -o-animation: blink 1s linear infinite;
            animation: imgs 1s linear infinite;
            -webkit-animation: imgs 1s linear infinite;
            -moz-animation: imgs 1s linear infinite;
            -ms-animation: imgs 1s linear infinite;
            -o-animation: imgs 1s linear infinite;
            z-index: 99;
            .img {
                width: 45px;
                height: 45px;
                margin-right: 13px;
                margin-bottom: -5px;
            }
        }
        @keyframes imgs {
            0% {
                opacity: 1; /*透明度为1*/
            }

            50% {
                opacity: 0;
            }

            100% {
                opacity: 1;
            }
        }
        @keyframes blink {
            0% {
                color: red;
            }

            50% {
                color: transparent;
            }

            100% {
                color: red;
            }
        }
    }

    // 头部
    .r-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 64px;
        background-color: #000;
        color: #bab7b7;
        font-size: 20px;

        .r-icon {
            img {
                height: 64px;
            }
        }

        .r-top-text {
            flex: 1;
            padding: 0 60px;
            display: flex;
            justify-content: space-between;

            .item {
                flex: 1;
                text-align: center;
            }
        }

        .r-top-time {
            flex-shrink: 0;
            padding-right: 35px;
        }
    }

    // 机器人数据展示
    .r-show-data {
        display: flex;
        flex: 1;
        background-color: #001529;

        .left-monitoring {
            height: 100%;
            width: 50%;
            position: relative;

            video {
                width: 100%;
                height: 100%;
            }

            .edition {
                width: 270px;
                position: absolute;
                top: 5%;
                left: 4%;
                z-index: 3;

                .edition-classification {
                    padding: 20px;
                }

                .tm {
                    background: rgba(0, 0, 0, 0.6) none repeat scroll !important;
                    background: #000;
                    filter: Alpha(opacity=60);
                    border-radius: 20px;
                    border: 1px solid #4c4f54;
                }
            }
        }

        /deep/.ivu-col-span-24 {
            flex: 1;
        }

        .right-monitoring {
            height: 100%;
            width: 50%;
            position: relative;

            .detailed {
                padding: 20px;
                overflow: hidden;
            }

            video {
                width: 100%;
                height: 100%;
            }

            .data-details {
                width: 300px;
                position: absolute;
                top: 5%;
                right: 4%;
                z-index: 3;

                .tm {
                    background: rgba(0, 0, 0, 0.6) none repeat scroll !important;
                    background: #000;
                    filter: Alpha(opacity=60);
                    border-radius: 20px;
                    border: 1px solid #4c4f54;
                }
            }
        }
    }

    // 底部
    .r-bottom {
        position: relative;
        height: 100px;
        width: 100%;
        flex-shrink: 0;
        background: url(../../../assets/images/lol/jg.png) no-repeat center;
        background-size: 100% 100%;
        background-color: #001529;

        .data-details {
            width: auto;
            position: absolute;
            top: -225%;
            right: 36%;
            z-index: 3;

            .tm {
                height: auto;
                background: rgba(0, 0, 0, 0.6) none repeat scroll !important;
                background: #000;
                filter: Alpha(opacity=60);
                border-radius: 20px;
                border: 1px solid #4c4f54;

                .img {
                    -o-animation: warning 1s linear infinite;
                }
            }
        }

        .warning {
            padding-top: 15px;
            color: rgb(255, 123, 0);
            text-align: center;
            font-size: 26px;
            line-height: 100px;
            font-weight: bold;
            animation: warning 1s linear infinite;
            -webkit-animation: warning 1s linear infinite;
            -moz-animation: warning 1s linear infinite;
            -ms-animation: warning 1s linear infinite;
            animation: imgs 1s linear infinite;
            -webkit-animation: imgs 1s linear infinite;
            -moz-animation: imgs 1s linear infinite;
            -ms-animation: imgs 1s linear infinite;
            -o-animation: imgs 1s linear infinite;
            z-index: 99;

            .img {
                width: 25px;
                height: 25px;
                margin-right: 13px;
                margin-bottom: -5px;
            }
        }
        @keyframes imgs {
            0% {
                opacity: 1; /*透明度为1*/
            }

            50% {
                opacity: 0;
            }

            100% {
                opacity: 1;
            }
        }
        @keyframes warning {
            0% {
                color: rgb(255, 123, 0);
            }

            50% {
                color: transparent;
            }

            100% {
                color: rgb(255, 123, 0);
            }
        }

        .sindagis-map-compass {
            position: absolute;
            bottom: 25%;
            left: 3%;
            height: 150px;
            width: 150px;
            z-index: 2;
            text-align: center;
            background-image: url("../../../assets/images/lol/lpc.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;

            .center {
                position: absolute;
                outline: none;
                border: none;
                cursor: pointer;
                left: 64.5px;
                top: 16px;
                background-image: url("../../../assets/images/lol/lpz.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;
                width: 20px;
                height: 120px;
            }
        }

        .speed {
            height: 20px;
            width: 100%;
            position: absolute;
            bottom: 147%;
            z-index: 9999;
            text-align: center;
        }

        .special {
            position: absolute;
        }
    }

    .text-key {
        color: #ffffff;
        font-size: 12px;
        flex-wrap: nowrap;
    }
    .text-value {
        // padding-left: 5px;
        color: #00ffff;
        font-size: 15px;

        // white-space: nowrap;
        // overflow: hidden;
        // text-overflow: ellipsis;
    }
    .text-row {
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    // 不在线提示
    .state {
        position: absolute;
        bottom: 0;
        left: 0;
        background-color: #000c17;
        width: 100%;
        height: 100%;
        z-index: 10000;
    }

    .handle {
        margin: 5px;
        padding: 5px 21px 6px;
    }

    /* 科幻风格网枪按钮 */
    .sci-fi-btn.netgun-btn {
        position: relative;
        overflow: hidden;
        border: none !important;
        border-radius: 8px !important;
        background: linear-gradient(135deg, #00d4ff 0%, #0099cc 50%, #006699 100%) !important;
        box-shadow: 
            0 0 15px rgba(0, 212, 255, 0.6),
            inset 0 1px 0 rgba(255, 255, 255, 0.3),
            inset 0 -1px 0 rgba(0, 0, 0, 0.3) !important;
        color: #ffffff !important;
        font-weight: 600;
        font-size: 12px;
        letter-spacing: 1px;
        text-transform: uppercase;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        min-width: 60px;
        height: 32px;
        padding: 0 12px !important;
        cursor: pointer;
        transform-style: preserve-3d;
    }

    .sci-fi-btn.netgun-btn::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.4),
            transparent
        );
        transition: left 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        z-index: 1;
    }

    .sci-fi-btn.netgun-btn::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 0;
        height: 0;
        background: radial-gradient(
            circle,
            rgba(255, 255, 255, 0.3) 0%,
            transparent 70%
        );
        border-radius: 50%;
        transform: translate(-50%, -50%);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        z-index: 2;
    }

    .sci-fi-btn.netgun-btn:hover {
        transform: translateY(-3px) rotateX(5deg);
        box-shadow: 
            0 0 25px rgba(0, 212, 255, 1),
            0 8px 25px rgba(0, 212, 255, 0.4),
            inset 0 1px 0 rgba(255, 255, 255, 0.4),
            inset 0 -1px 0 rgba(0, 0, 0, 0.4) !important;
        background: linear-gradient(135deg, #00f0ff 0%, #00ccff 50%, #0088cc 100%) !important;
    }

    .sci-fi-btn.netgun-btn:hover::before {
        left: 100%;
    }

    .sci-fi-btn.netgun-btn:hover::after {
        width: 100%;
        height: 100%;
        border-radius: 8px;
    }

    .sci-fi-btn.netgun-btn:active {
        transform: translateY(-1px) rotateX(2deg);
        box-shadow: 
            0 0 20px rgba(0, 212, 255, 0.8),
            0 4px 15px rgba(0, 212, 255, 0.3),
            inset 0 2px 4px rgba(0, 0, 0, 0.4) !important;
        background: linear-gradient(135deg, #0099cc 0%, #006699 50%, #004466 100%) !important;
    }

    /* 按钮容器的发光背景效果 */
    .kz .sci-fi-btn.netgun-btn {
        margin: 8px 4px;
        position: relative;
    }

    .kz .sci-fi-btn.netgun-btn:nth-child(1) {
        animation: glow-pulse-1 2s ease-in-out infinite;
    }

    .kz .sci-fi-btn.netgun-btn:nth-child(2) {
        animation: glow-pulse-2 2s ease-in-out infinite 0.5s;
    }

    @keyframes glow-pulse-1 {
        0%, 100% {
            box-shadow: 
                0 0 15px rgba(0, 212, 255, 0.6),
                inset 0 1px 0 rgba(255, 255, 255, 0.3),
                inset 0 -1px 0 rgba(0, 0, 0, 0.3);
        }
        50% {
            box-shadow: 
                0 0 25px rgba(0, 212, 255, 0.9),
                0 0 35px rgba(0, 212, 255, 0.3),
                inset 0 1px 0 rgba(255, 255, 255, 0.3),
                inset 0 -1px 0 rgba(0, 0, 0, 0.3);
        }
    }

    @keyframes glow-pulse-2 {
        0%, 100% {
            box-shadow: 
                0 0 15px rgba(0, 212, 255, 0.6),
                inset 0 1px 0 rgba(255, 255, 255, 0.3),
                inset 0 -1px 0 rgba(0, 0, 0, 0.3);
        }
        50% {
            box-shadow: 
                0 0 25px rgba(0, 255, 200, 0.9),
                0 0 35px rgba(0, 255, 200, 0.3),
                inset 0 1px 0 rgba(255, 255, 255, 0.3),
                inset 0 -1px 0 rgba(0, 0, 0, 0.3);
        }
    }

    /* 行为拒止按钮样式 */
    .sci-fi-btn.behavior-prohibition-btn {
        position: relative;
        overflow: hidden;
        border: none !important;
        border-radius: 8px !important;
        background: linear-gradient(135deg, #ff9900 0%, #ff6600 50%, #cc4400 100%) !important;
        box-shadow: 
            0 0 15px rgba(255, 153, 0, 0.6),
            inset 0 1px 0 rgba(255, 255, 255, 0.3),
            inset 0 -1px 0 rgba(0, 0, 0, 0.3) !important;
        color: #ffffff !important;
        font-weight: 600;
        font-size: 12px;
        letter-spacing: 1px;
        text-transform: uppercase;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        min-width: 80px;
        height: 32px;
        padding: 0 12px !important;
        cursor: pointer;
        transform-style: preserve-3d;
    }
    
    .sci-fi-btn.behavior-prohibition-btn::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.4),
            transparent
        );
        transition: left 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        z-index: 1;
    }
    
    .sci-fi-btn.behavior-prohibition-btn:hover {
        transform: translateY(-3px) rotateX(5deg);
        box-shadow: 
            0 0 25px rgba(255, 153, 0, 1),
            0 8px 25px rgba(255, 153, 0, 0.4),
            inset 0 1px 0 rgba(255, 255, 255, 0.4),
            inset 0 -1px 0 rgba(0, 0, 0, 0.4) !important;
        background: linear-gradient(135deg, #ffaa00 0%, #ff7700 50%, #ee5500 100%) !important;
    }
    
    .sci-fi-btn.behavior-prohibition-btn:hover::before {
        left: 100%;
    }
    
    .sci-fi-btn.behavior-prohibition-btn .ivu-icon {
        animation: behavior-icon-pulse 2s ease-in-out infinite;
    }
    
    /* 停止行为拒止按钮样式 */
    .sci-fi-btn.stop-behavior-btn {
        position: relative;
        overflow: hidden;
        border: none !important;
        border-radius: 8px !important;
        background: linear-gradient(135deg, #6cf0f5 0%, #00ccdd 50%, #0099bb 100%) !important;
        box-shadow: 
            0 0 15px rgba(108, 240, 245, 0.6),
            inset 0 1px 0 rgba(255, 255, 255, 0.3),
            inset 0 -1px 0 rgba(0, 0, 0, 0.3) !important;
        color: #ffffff !important;
        font-weight: 600;
        font-size: 12px;
        letter-spacing: 1px;
        text-transform: uppercase;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        min-width: 80px;
        height: 32px;
        padding: 0 12px !important;
        cursor: pointer;
        transform-style: preserve-3d;
    }
    
    .sci-fi-btn.stop-behavior-btn::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.4),
            transparent
        );
        transition: left 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        z-index: 1;
    }
    
    .sci-fi-btn.stop-behavior-btn:hover {
        transform: translateY(-3px) rotateX(5deg);
        box-shadow: 
            0 0 25px rgba(108, 240, 245, 1),
            0 8px 25px rgba(108, 240, 245, 0.4),
            inset 0 1px 0 rgba(255, 255, 255, 0.4),
            inset 0 -1px 0 rgba(0, 0, 0, 0.4) !important;
        background: linear-gradient(135deg, #7df5fa 0%, #11ddee 50%, #00aacc 100%) !important;
    }
    
    .sci-fi-btn.stop-behavior-btn:hover::before {
        left: 100%;
    }
    
    .sci-fi-btn.stop-behavior-btn .ivu-icon {
        animation: stop-icon-pulse 1.5s ease-in-out infinite;
    }
    
    /* 按钮图标动画 */
    @keyframes behavior-icon-pulse {
        0%, 100% {
            transform: scale(1);
            opacity: 1;
        }
        50% {
            transform: scale(1.1);
            opacity: 0.8;
        }
    }
    
    @keyframes stop-icon-pulse {
        0%, 100% {
            transform: scale(1) rotate(0deg);
        }
        50% {
            transform: scale(1.05) rotate(5deg);
        }
    }
    
    /* 加强按钮发光效果 */
    .kz .sci-fi-btn.behavior-prohibition-btn {
        animation: behavior-glow-pulse 3s ease-in-out infinite;
    }
    
    .kz .sci-fi-btn.stop-behavior-btn {
        animation: stop-glow-pulse 2.5s ease-in-out infinite 0.7s;
    }
    
    @keyframes behavior-glow-pulse {
        0%, 100% {
            box-shadow: 
                0 0 15px rgba(255, 153, 0, 0.6),
                inset 0 1px 0 rgba(255, 255, 255, 0.3),
                inset 0 -1px 0 rgba(0, 0, 0, 0.3);
        }
        50% {
            box-shadow: 
                0 0 25px rgba(255, 153, 0, 0.9),
                0 0 35px rgba(255, 153, 0, 0.3),
                inset 0 1px 0 rgba(255, 255, 255, 0.3),
                inset 0 -1px 0 rgba(0, 0, 0, 0.3);
        }
    }
    
    @keyframes stop-glow-pulse {
        0%, 100% {
            box-shadow: 
                0 0 15px rgba(108, 240, 245, 0.6),
                inset 0 1px 0 rgba(255, 255, 255, 0.3),
                inset 0 -1px 0 rgba(0, 0, 0, 0.3);
        }
        50% {
            box-shadow: 
                0 0 25px rgba(108, 240, 245, 0.9),
                0 0 35px rgba(108, 240, 245, 0.3),
                inset 0 1px 0 rgba(255, 255, 255, 0.3),
                inset 0 -1px 0 rgba(0, 0, 0, 0.3);
        }
    }
    
    /* 语音喊话按钮样式 */
    .sci-fi-btn.intercom-btn {
        position: relative;
        overflow: hidden;
        border: none !important;
        border-radius: 8px !important;
        background: linear-gradient(135deg, #5b8af7 0%, #3366ff 50%, #2244cc 100%) !important;
        box-shadow: 
            0 0 15px rgba(51, 102, 255, 0.6),
            inset 0 1px 0 rgba(255, 255, 255, 0.3),
            inset 0 -1px 0 rgba(0, 0, 0, 0.3) !important;
        color: #ffffff !important;
        font-weight: 600;
        font-size: 12px;
        letter-spacing: 1px;
        text-transform: uppercase;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        min-width: 80px;
        height: 32px;
        padding: 0 12px !important;
        cursor: pointer;
        transform-style: preserve-3d;
    }
    
    .sci-fi-btn.intercom-btn::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.4),
            transparent
        );
        transition: left 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        z-index: 1;
    }
    
    .sci-fi-btn.intercom-btn:hover {
        transform: translateY(-3px) rotateX(5deg);
        box-shadow: 
            0 0 25px rgba(51, 102, 255, 1),
            0 8px 25px rgba(51, 102, 255, 0.4),
            inset 0 1px 0 rgba(255, 255, 255, 0.4),
            inset 0 -1px 0 rgba(0, 0, 0, 0.4) !important;
        background: linear-gradient(135deg, #6c9af8 0%, #4477ff 50%, #3355dd 100%) !important;
    }
    
    .sci-fi-btn.intercom-btn:hover::before {
        left: 100%;
    }
    
    .sci-fi-btn.intercom-btn .ivu-icon {
        animation: intercom-icon-pulse 2s ease-in-out infinite;
    }
    
    /* 音频播放按钮样式 */
    .sci-fi-btn.audio-play-btn {
        position: relative;
        overflow: hidden;
        border: none !important;
        border-radius: 8px !important;
        background: linear-gradient(135deg, #19be6b 0%, #13a357 50%, #0f8844 100%) !important;
        box-shadow: 
            0 0 15px rgba(25, 190, 107, 0.6),
            inset 0 1px 0 rgba(255, 255, 255, 0.3),
            inset 0 -1px 0 rgba(0, 0, 0, 0.3) !important;
        color: #ffffff !important;
        font-weight: 600;
        font-size: 12px;
        letter-spacing: 1px;
        text-transform: uppercase;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        min-width: 80px;
        height: 32px;
        padding: 0 12px !important;
        cursor: pointer;
        transform-style: preserve-3d;
    }
    
    .sci-fi-btn.audio-play-btn::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.4),
            transparent
        );
        transition: left 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        z-index: 1;
    }
    
    .sci-fi-btn.audio-play-btn:hover {
        transform: translateY(-3px) rotateX(5deg);
        box-shadow: 
            0 0 25px rgba(25, 190, 107, 1),
            0 8px 25px rgba(25, 190, 107, 0.4),
            inset 0 1px 0 rgba(255, 255, 255, 0.4),
            inset 0 -1px 0 rgba(0, 0, 0, 0.4) !important;
        background: linear-gradient(135deg, #2ace7f 0%, #19be6b 50%, #13a357 100%) !important;
    }
    
    .sci-fi-btn.audio-play-btn:hover::before {
        left: 100%;
    }
    
    .sci-fi-btn.audio-play-btn .ivu-icon {
        animation: audio-icon-pulse 1.8s ease-in-out infinite;
    }
    
    /* 语音喊话图标动画 */
    @keyframes intercom-icon-pulse {
        0%, 100% {
            transform: scale(1);
            opacity: 1;
        }
        50% {
            transform: scale(1.15);
            opacity: 0.85;
        }
    }
    
    /* 音频播放图标动画 */
    @keyframes audio-icon-pulse {
        0%, 100% {
            transform: scale(1) rotate(0deg);
            opacity: 1;
        }
        25% {
            transform: scale(1.1) rotate(-5deg);
        }
        75% {
            transform: scale(1.1) rotate(5deg);
        }
    }
    
    /* 语音喊话按钮发光效果 */
    .kz .sci-fi-btn.intercom-btn {
        animation: intercom-glow-pulse 2.8s ease-in-out infinite;
    }
    
    @keyframes intercom-glow-pulse {
        0%, 100% {
            box-shadow: 
                0 0 15px rgba(51, 102, 255, 0.6),
                inset 0 1px 0 rgba(255, 255, 255, 0.3),
                inset 0 -1px 0 rgba(0, 0, 0, 0.3);
        }
        50% {
            box-shadow: 
                0 0 25px rgba(51, 102, 255, 0.9),
                0 0 35px rgba(51, 102, 255, 0.3),
                inset 0 1px 0 rgba(255, 255, 255, 0.3),
                inset 0 -1px 0 rgba(0, 0, 0, 0.3);
        }
    }
    
    /* 音频播放按钮发光效果 */
    .kz .sci-fi-btn.audio-play-btn {
        animation: audio-glow-pulse 2.5s ease-in-out infinite 0.4s;
    }
    
    @keyframes audio-glow-pulse {
        0%, 100% {
            box-shadow: 
                0 0 15px rgba(25, 190, 107, 0.6),
                inset 0 1px 0 rgba(255, 255, 255, 0.3),
                inset 0 -1px 0 rgba(0, 0, 0, 0.3);
        }
        50% {
            box-shadow: 
                0 0 25px rgba(25, 190, 107, 0.9),
                0 0 35px rgba(25, 190, 107, 0.3),
                inset 0 1px 0 rgba(255, 255, 255, 0.3),
                inset 0 -1px 0 rgba(0, 0, 0, 0.3);
        }
    }
    /deep/.data-details .sci-fi-btn.ivu-btn[disabled]{
        color: #c5c8ce !important;
        background: #f7f7f7 !important;
        cursor: not-allowed!important;
        color: #c5c8ce !important;
        font-weight: normal !important;
        text-shadow: none !important;
        transform:none !important;
        box-shadow:none !important;
    }
</style>
